const USER_INFO_KEY = 'surveyUserInfo';
import { getDeptTree, getUserList } from '@/management/api/userManage';
import { merge as _merge } from 'lodash-es';

export default {
  namespaced: true,
  state: {
    userInfo: {
      token: '',
      username: '',
      role: null,
      deptInfo: null,
      avatar: null,
    },
    deptTreeData: [],
    hasLogined: false,
    loginTime: null,
    initialized: false,
    searchUserParams: {
      pageNum: 1,
      pageSize: 10,
      role: null,
      userName: null,
      deptId: null,
    },
    userListTotal: 0,
    userList: [],
  },
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setDeptTree(state, data) {
      state.deptTreeData = data;
    },
    setUserList(state, data) {
      state.userList = data;
    },
    setHsLogined(state, data) {
      state.hasLogined = data;
    },
    setLoginTime(state, data) {
      state.loginTime = data;
    },
    setInitialized(state, data) {
      state.initialized = data;
    },
  },
  actions: {
    init({ dispatch, commit }) {
      const localData = localStorage.getItem(USER_INFO_KEY);
      if (localData) {
        try {
          const { userInfo, loginTime } = JSON.parse(localData);
          if (Date.now() - loginTime > 7 * 3600000) {
            localStorage.removeItem(USER_INFO_KEY);
          } else {
            dispatch('login', userInfo);
          }
        } catch (error) {
          console.log(error);
        }
      }
      commit('setInitialized', true);
    },
    login({ commit }, data) {
      const loginTime = Date.now();
      commit('setUserInfo', data);
      commit('setHsLogined', true);
      commit('setLoginTime', loginTime);
      localStorage.setItem(
        USER_INFO_KEY,
        JSON.stringify({
          userInfo: data,
          loginTime: loginTime,
        })
      );
    },
    logout({ commit }) {
      commit('setUserInfo', null);
      commit('setHsLogined', false);
      localStorage.removeItem(USER_INFO_KEY);
    },
    getDeptData({ commit }) {
      try {
        getDeptTree().then((res) => {
          if (res.code == 200 && res.data) {
            commit('setDeptTree', renameKeysRecursive(res.data));
          } else {
            throw new Error(res.msg);
          }
        });
      } catch (error) {}
    },
    async getUserList({ state, commit }) {
      await getUserList(state.searchUserParams).then((res) => {
        if (res.code && res.code == 200) {
          // 头像null  则设置默认头像
          res.data.list.forEach((item) => {
            if (!item.headImg) {
              item.headImg =
                'https://sc-survey.oss-cn-chengdu.aliyuncs.com/public/65fbe05b45142e830331ea31.png';
            }
          });
          state.userListTotal = res.data.total;
          commit('setUserList', res.data.list);
        } else {
          throw new Error(res.msg);
        }
      });
    },
  },
};
// 修改部门树data-key值
function renameKeysRecursive(obj) {
  function renameKeys(obj) {
    if (Array.isArray(obj)) {
      return obj.map((item) => renameKeys(item));
    } else if (typeof obj === 'object' && obj !== null) {
      const newObj = {};
      Object.keys(obj).forEach((key) => {
        const newKey =
          key === '_id'
            ? 'id'
            : key === 'deptName'
            ? 'label'
            : key === 'child'
            ? 'children'
            : key;
        newObj[newKey] = renameKeys(obj[key]);
      });
      return newObj;
    }
    return obj;
  }
  return renameKeys(obj);
}
